import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Stack,
  IconButton,
  InputAdornment
} from '@mui/material';
import { Visibility, VisibilityOff, LockOutlined, LogoutOutlined } from '@mui/icons-material';
import useAuth from 'app/hooks/useAuth';
import DOMPurify from 'dompurify';

const PopUpLogin = ({ open, onClose }) => {
  const { login, logout } = useAuth();
  const navigate = useNavigate();
  const email = JSON.parse(localStorage.getItem('user'))?.Email;

  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!password || loading) return;

    try {
      setLoading(true);

      const resp = await login(
        DOMPurify.sanitize(email),
        DOMPurify.sanitize(password)
      );
      if (resp?.success) {
        setPassword('');
        onClose();
        navigate(0);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    logout();
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      disableAutoFocus
      container={() => document.body}
    >
      <Box
        sx={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 360,
          bgcolor: 'background.paper',
          borderRadius: 2,
          p: 3,
          outline: 'none',
          zIndex: 20000
        }}
      >
        <Box textAlign="center" mb={2}>
          <LockOutlined color="primary" sx={{ fontSize: 40 }} />
          <Typography variant="h6">SESSION EXPIRED</Typography>
          <Typography variant="body2" color="text.secondary">
            Re-enter your password to continue or choose logout to exit memosign.
          </Typography>
        </Box>

        <Stack spacing={2}>
          <TextField
            label="Password"
            type={showPassword ? 'text' : 'password'}
            fullWidth
            size="small"
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword((v) => !v)}
                    edge="end"
                    size="small"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <Button
            variant="contained"
            size="large"
            onClick={handleSubmit}
            disabled={!password || loading}
          >
            {loading ? 'SIGNING IN…' : 'LOGIN AGAIN'}
          </Button>

            <Button
                variant="outlined"
                color="error"
                startIcon={<LogoutOutlined />}
                onClick={handleLogout}
            >
                KEEP LOGOUT
            </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default PopUpLogin;
